<template>
  <div class="box">
    <div class="image-box">
      <img src="../assets/image/phone.png" alt />
    </div>
    <div class="content">
      <div class="text">
        <p>集体经济APP 已在常用应用市场上线，下载可前往各手机自带应用市场平台搜索“集体经济”即可进行下载.目前已上线的应用市场包括：【华为，小米，oppo,360等】</p>
      </div>
      <div class="btn">
        <div class="app-btn" @click="androidBtn()">
          <div class="icon">
            <img src="../assets/image/安卓.png" alt />
          </div>
          <div class="btn-text">安卓手机下载</div>
          <div class="clear-both"></div>
        </div>
        <div class="clear-both" style="margin-top:20px"></div>
        <div class="app-btn" @click="iosBtn()">
          <div class="icon">
            <img src="../assets/image/IOS.png" alt />
          </div>
          <div class="btn-text">ios 苹果下载</div>
          <div class="clear-both"></div>
        </div>
      </div>
    </div>
    <div class="msg">【注：微信扫码请使用浏览器打开】</div>
    <div class="footer-box"></div>
    <div class="footer">
      <span>
        <a href="https://www.zyyunxun.cn">遵义云讯网络科技有限责任公司</a>
      </span>
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52030302000614"
        target="_blank"
        class="beian"
      >
        <p style>
          <img src="../assets/image/beian.png" class="image-box1" />
          <span>黔ICP备19011880号 &copy;2019-2022</span>
        </p>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: "appLoad",
  data() {
    return {
      apk: "",
      ipa: ""
    };
  },
  methods: {
    androidBtn() {
      window.location.href = this.apk;
    },
    iosBtn() {
      window.location.href = this.ipa;
    }
  },
  mounted() {

    let cnt = {};
    this.$api.getVersion(cnt, res => {
      let data = JSON.parse(res.data.c);
      this.apk = data.android;
      this.ipa = data.ios;
    });
  }
};
</script>


<style lang="scss" scoped>
a {
  text-decoration: none;
  color: #666;
}
.clear-both {
  clear: both;
}
.box {
  width: 100%;
  min-height: 100%;
  background: rgba(57, 207, 202, 0.7);
  overflow: hidden;
}
.image-box {
  // position: relative;
  padding-top: 5rem;
  padding-left: 40%;
  width: 10rem;
  img {
    width: 10rem;
  }
}
.content {
  padding: 2rem;
  width: auto;
}
.text {
  width: auto;
  text-align: center;
  font-size: 1.4rem;
  line-height: 3rem;
  color: #555;
}
.btn {
  margin-left: 20%;
  width: 25rem;
  margin-top: 2rem;
  width: 100%;
}
.app-btn {
  width: 25rem;
  height: 5rem;
  background: #fff;
  border-radius: 1rem;
  cursor: pointer;
}
.icon {
  float: left;
  margin-top: 1rem;
  margin-left: 1rem;
  width: 3rem;
  height: 3rem;
  img {
    width: 3rem;
    height: 3rem;
  }
}
.btn-text {
  float: left;
  width: 20rem;
  text-align: center;
  line-height: 5rem;
  font-size: 1.6rem;
  color: #666;
  letter-spacing: 0.5rem;
}

.footer {
  position: fixed;
  bottom: 2rem;
  width: 100%;
  height: 6rem;
  color: #666;
  font-size: 1.4rem;
  text-align: center;
}
.image-box1 {
  margin-top: 0.5rem;
  width: 2rem;
  height: 2rem;
}
.msg {
  padding-left: 4rem;
  text-align: center;
  color: #666;
}
.footer-box {
  width: 100%;
  height: 8rem;
}
</style>

